import React from 'react';

import {Container, LinkButtonText} from './styles';
import {useTheme} from 'styled-components/native';
import { RFValue } from 'react-native-responsive-fontsize';

interface Props {
  action: () => void;
  text: string;
  color?: string;
  enabled: boolean;
  fontSize?: number;
}

export function LinkButton({action, text, color, enabled, fontSize}: Props) {
  const theme = useTheme();
  return (
    <Container
      activeOpacity={1}
      onPress={action}
      style={{
        opacity: enabled ? 1 : 0.5,
        borderColor: color ? color : theme.colors.blue,
      }}
      disabled={!enabled}>
      <LinkButtonText style={{color: color ? color : theme.colors.blue, fontSize: fontSize ? fontSize : RFValue(12)}}>
        {text}
      </LinkButtonText>
    </Container>
  );
}
